"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitMetaCSSDependenciesBFS = void 0;
function visitMetaCSSDependenciesBFS(meta, onMetaDependency, resolver) {
    const visited = new Set([meta.source]);
    const q = [[...meta.imports]];
    let depth = -1;
    while (++depth < q.length) {
        let index = -1;
        const items = q[depth];
        if (items.length && !q[depth + 1]) {
            q[depth + 1] = [];
        }
        while (++index < items.length) {
            const imported = items[index];
            const res = resolver.resolveImported(imported, '');
            if ((res === null || res === void 0 ? void 0 : res._kind) === 'css' && !visited.has(res.meta.source)) {
                visited.add(res.meta.source);
                onMetaDependency(res.meta, imported, depth + 1);
                q[depth + 1].push(...res.meta.imports);
            }
        }
    }
}
exports.visitMetaCSSDependenciesBFS = visitMetaCSSDependenciesBFS;
//# sourceMappingURL=visit-meta-css-dependencies.js.map